export default {
  'login.form.title': '登录',
  'login.form.userName.errMsg': '用户名不能为空',
  'login.form.password.errMsg': '密码不能为空',
  'login.form.login.errMsg': '登录出错，轻刷新重试',
  'login.form.login.success': '欢迎使用',
  'login.form.userName.placeholder': '用户名：admin',
  'login.form.password.placeholder': '密码：admin',
  'login.form.rememberPassword': '记住密码',
  'login.form.forgetPassword': '忘记密码',
  'login.form.login': '登录',
  'login.form.register': '注册账号',
  'login.banner.slogan1': '',
  'login.banner.subSlogan1': '',
  'login.banner.slogan2': '',
  'login.banner.subSlogan2': '',
  'login.banner.slogan3': '',
  'login.banner.subSlogan3': '',
};
